import React, { useState, useEffect } from 'react';
import { Grid, Typography, Button, Chip } from '@mui/material';

// SERVICES
import { getCorreos } from '../../services/config_correos/getDatosCorreos';

// ICONOS
import AddIcon from '@mui/icons-material/Add';

// COMPONENTES
import MiTabla from '../../components/plantilla/tabla/MiTabla';
import AgregarCorreo from './modales/AgregarCorreo';
import EditarCorreo from './modales/EditarCorreo';

const ConfigCorreos = () => {

    const [correos, setCorreos] = useState([]);

    const getData = async () => {

        const data = await getCorreos();
        setCorreos(data);

    }

    // =========================================
    // ESTADOS PARA MODAL
    // =========================================

    const [showModal, setShowModal] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);

    // =========================================
    // COLUMNAS
    // =========================================

    const columns = [

        { 
            field: 'email', 
            headerName: 'Correo',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'is_active', 
            headerName: 'Status',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => params.row.is_active === 1 ? <Chip label='Activo' color='success' /> : <Chip label='Inactivo' color='error' />
        },

    ];

    // =========================================
    // FUNCION PARA SELECCIONAR FILA
    // =========================================

    const [selected, setSelected] = useState({
        descripcion: '',
        severity: ''
    });

    const selectRow = ( params ) => {

        setSelected(params.row);
        setShowModalEdit(true);

    }

    // =========================================
    // USE  EFFECT PARA OBTENER DATOS
    // =========================================

    useEffect(() => {

        getData();

    }, []);

    // =========================================

    return (

        <Grid container>

            {/* TITULO */}

            <Grid size={6} marginBottom={2}>

                <Typography
                    variant="h5"
                    fontWeight={700}
                >
                    Catalogo de Correos
                </Typography>

            </Grid>

            {/* BOTONES */}

            <Grid 
                size={6} 
                marginBottom={2}
                sx={{ 
                    display: 'flex', 
                    justifyContent: 'flex-end' 
                }}
            >

                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={() => setShowModal(true)}
                    sx={{
                        backgroundColor: 'black'
                    }}
                >
                    Agregar Correo
                </Button>

            </Grid>

            {/* TABLA */}

            <Grid size={12}>

                <MiTabla
                    columns={columns}
                    data={correos}
                    onRowClick={selectRow}
                />

            </Grid>

            {/* MODAL AGREGAR CORREO */}

            <AgregarCorreo
                open={showModal}
                onClose={() => setShowModal(false)}
                refresh={getData}
            />

            {/* MODAL EDITAR CORREO */}

            <EditarCorreo
                open={showModalEdit}
                onClose={() => setShowModalEdit(false)}
                refresh={getData}
                data={selected}
            />

        </Grid>

    )

}

export default ConfigCorreos